import React from 'react';
import { ScheduleTable } from '../../components/ScheduleTable';
import { LocationBlock } from '../../components/LocationBlock';
export function FarmingtonScheduleLocation() {
  return <section className="py-24 bg-paper border-y border-subtle-gray" data-id="element-1315">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1316">
        <div className="grid lg:grid-cols-2 gap-16" data-id="element-1317">
          <div data-id="element-1318">
            <h2 className="text-4xl text-ink mb-8" data-id="element-1319">Class Times</h2>
            <ScheduleTable data-id="element-1320" />
          </div>
          <div data-id="element-1321">
            <h2 className="text-4xl text-ink mb-8" data-id="element-1322">Location Details</h2>
            <LocationBlock data-id="element-1323" />
          </div>
        </div>
      </div>
    </section>;
}